module.exports = __webpack_public_path__ + "1f8f5740309e62a563b8a5c9d59ece3b.ttf";